import { Component, HostListener, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import {
  ReactiveFormsModule,
  FormBuilder,
  Validators,
  FormGroup,
  FormsModule
} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { PropertyService } from '../../../_services/properties/property.service';
import { ToastService } from '../../../_services/toast.service';

@Component({
  selector: 'app-customer-preference',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, FormsModule],
  templateUrl: './customer-preference.component.html',
  styleUrls: ['./customer-preference.component.scss']
})
export class CustomerPreferenceComponent implements OnInit {

  form!: FormGroup;
  @ViewChild('searchInput') searchInput!: ElementRef;
  isSubmitting = false;
  searchMarket: string = '';
  userDetails:any
  // Dropdown states
  isMarketOpen = false;
  isApartmentOpen = false;
  isCompletionOpen = false;
  constructor(private fb: FormBuilder, private http: HttpClient,private _PS: PropertyService,private _NS : ToastService, private router: Router,) {
    const user = typeof window !== 'undefined' ? localStorage.getItem('Cirlced_User') : null;
      this.userDetails = user ? JSON.parse(user) : null;
    this.form = this.fb.nonNullable.group({
      microMarkets: [[] as string[], Validators.required],
      apartmentType: ['', Validators.required],
      budget: ['', Validators.required],
      configuration: ['', Validators.required],
      completion: [[] as string[]],
      notes:['']
    });
  }

  // -------------------------
  // Data
  // -------------------------

  microMarkets:any =[]

  budgetRanges: string[] = [
    '₹0 – ₹5 Cr',
    '₹5 Cr – ₹10 Cr',
    '₹10 Cr – ₹15 Cr',
    '₹15 Cr – ₹25 Cr',
    '₹25 Cr+'
  ];

  configurations: string[] = [
    '3BHK (2,500Sq ft to 3,000Sq ft)',
    '3BHK + Maids (2,800Sq ft to 3,200Sq ft)',
    '4BHK + Maids (3,000Sq ft to 4,000Sq ft)',
    '5BHK + Maids (4,000Sq ft to 7,000Sq ft)',
    'Pent House - 3/4BHK',
    'Villa’s',
    'Independent plot',
    'Independent plot with a house'
  ];

  apartmentPreference: string[] = [
    'Boutique apartment (8–10 units, prime address)',
    'Large community (25+ units with amenities)',
    'Ok with anything'
  ];

  completionPreference: string[] = [
    'Under construction (up to 3 years)',
    'Nearing completion (6–12 months)',
    'Ready to move-in',
    'Resale – Older apartments',
    'Ok with all'
  ];

  // -------------------------
  // Dropdown Logic
  // -------------------------

  ngOnInit(): void {
    this._PS.getAllCluster().subscribe((res:any)=>{
      this.microMarkets = Array.from(
        new Map(
          res.map((m: any) => [m.micromarketName, m])
        ).values()
      );
    })
  }

  get filteredMarkets() {
    const search = this.searchMarket?.toLowerCase()?.trim();

    const list = !search
      ? this.microMarkets
      : this.microMarkets.filter((m: any) => {
          const name = (m?.micromarketName || '').toLowerCase();
          return name.includes(search);
        });

    const selected = this.form.controls['microMarkets'].value;

    return list.sort((a: any, b: any) => {
      const aSelected = selected.includes(a.micromarketName);
      const bSelected = selected.includes(b.micromarketName);
      return Number(bSelected) - Number(aSelected);
    });
  }

  toggleDropdown(type: 'market' | 'apartment' | 'completion'): void {
    if (type === 'market') {
      this.isMarketOpen = !this.isMarketOpen;
      this.isApartmentOpen = false;
      this.isCompletionOpen = false;

      if (this.isMarketOpen) {
        setTimeout(() => {
          this.searchInput?.nativeElement.focus();
        }, 0);
      } else {
        this.searchMarket = '';
      }

    } else if (type === 'apartment') {
      this.isApartmentOpen = !this.isApartmentOpen;
      this.isMarketOpen = false;
      this.isCompletionOpen = false;

    } else if (type === 'completion') {
      this.isCompletionOpen = !this.isCompletionOpen;
      this.isMarketOpen = false;
      this.isApartmentOpen = false;
    }
  }

  // Close dropdown when clicking outside
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown-wrapper')) {
      this.isMarketOpen = false;
      this.isApartmentOpen = false;
      this.isCompletionOpen = false;
    }
  }

  // -------------------------
  // Chip Selection Logic
  // -------------------------

  selectOption(
    controlName: 'microMarkets' | 'apartmentType' | 'completion',
    value: string,
    max?: number
  ): void {

    const control = this.form.controls[controlName];
    const current: string[] = control.value;

    if (current.includes(value)) {
      control.setValue(
        current.filter((v: string) => v !== value)
      );
    } else {
      if (max && current.length >= max) return;
      control.setValue([...current, value]);
    }
  }

  removeChip(
    controlName: 'microMarkets' | 'apartmentType' | 'completion',
    value: string
  ): void {

    const control = this.form.controls[controlName];
    const current: string[] = control.value;

    control.setValue(
      current.filter((v: string) => v !== value)
    );
  }

  // -------------------------
  // Submit
  // -------------------------

  submit(): void {
    if (this.form.invalid) return;
    this.isSubmitting = true;
    const value = this.form.getRawValue();

    let reqObject = {
      budgetRange: this._PS.parsePriceRange(value.budget),
      microMarkets: value.microMarkets,
      configuration: value.configuration,
      communityPreference: value.apartmentType[0],
      projectStatus: value.completion,
      isRequestSource: 'User',
      notes: value.notes,
      reqUser: {
        email: this.userDetails.data.email,
        name: this.userDetails.data.name,
        id: this.userDetails.data._id,
        phone: this.userDetails.data.phone,
        type: this.userDetails?.data.isUserType ?? 'Basic'
      },
    }
    this._PS.createUserPreference(reqObject).subscribe({
      next: () => {
        this.isSubmitting = false;
        this._NS.success('Preferences sent successfully!');

        this.showSuccessPopup = true;

        this.form.reset({
          microMarkets: [],
          apartmentType: [],
          budget: '',
          configuration: '',
          completion: []
        });
      },
      error: () => {
        this.isSubmitting = false;
        this._NS.error('Something went wrong.');
      }
    });
  }

  showSuccessPopup = false;

  closePopup() {
    this.showSuccessPopup = false;
  }

  goToListings() {
    this.showSuccessPopup = false;
    // navigate to listings page
    this.router.navigate(['/search']); // update route if needed
  }
}